import type { ConflictItem } from '../../../lib/schedule'

interface Props {
  conflicts: ConflictItem[]
}

/**
 * Both callers refuse to save while a conflict stands — `CalendarPlanningOverlay` disables its
 * Speichern button, and `PausePopover` does the same — so "Speichern nicht möglich" is a true
 * statement wherever this renders, and red is the right colour for it.
 */
export function ConflictWarning({ conflicts }: Props) {
  if (conflicts.length === 0) return null

  return (
    <div className="mx-4 mb-3 rounded-lg bg-red-50 border border-red-200 px-3 py-2.5">
      <div className="flex items-center gap-1.5 mb-1.5">
        <span className="text-red-500 text-sm leading-none">✕</span>
        <p className="text-xs font-semibold text-red-700">
          Überschneidung — Speichern nicht möglich
        </p>
      </div>
      <ul className="space-y-0.5">
        {conflicts.map((c, i) => (
          <li key={i} className="text-xs text-red-600 flex gap-1.5">
            <span className="font-medium shrink-0">{c.timeLabel}</span>
            <span>{c.label}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
